var _circle, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFileUploadIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 99,
    height: 99,
    viewBox: "0 0 99 99",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 49.5,
    cy: 49.5,
    r: 49.5,
    fill: "#F9F9F9"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.15
  }, /*#__PURE__*/React.createElement("path", {
    d: "M65.8265 50.6274C65.8265 59.518 58.4776 66.721 49.407 66.721C40.3364 66.721 33 59.518 33 50.6274C33 41.7368 40.3488 34.546 49.4195 34.546",
    stroke: "#1A1A1A",
    strokeWidth: 3.8,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.2199 31V43.4846",
    stroke: "#1A1A1A",
    strokeWidth: 3.8,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.1866 37.2438H69.2535",
    stroke: "#1A1A1A",
    strokeWidth: 3.8,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.8519 53.0958C55.5054 53.0958 55.9377 53.7968 55.6964 54.4446C54.701 57.0786 52.2578 58.9372 49.4124 58.9372C46.567 58.9372 44.1238 57.0786 43.1284 54.4446C42.8871 53.8074 43.3195 53.0958 43.973 53.0958H54.8619H54.8519Z",
    fill: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.404 48.3999C45.5736 48.3999 46.5218 47.4189 46.5218 46.2089C46.5218 44.9988 45.5736 44.0178 44.404 44.0178C43.2344 44.0178 42.2863 44.9988 42.2863 46.2089C42.2863 47.4189 43.2344 48.3999 44.404 48.3999Z",
    fill: "#1A1A1A",
    stroke: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.424 48.3999C55.5936 48.3999 56.5417 47.4189 56.5417 46.2089C56.5417 44.9988 55.5936 44.0178 54.424 44.0178C53.2544 44.0178 52.3062 44.9988 52.3062 46.2089C52.3062 47.4189 53.2544 48.3999 54.424 48.3999Z",
    fill: "#1A1A1A",
    stroke: "#1A1A1A"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileUploadIcon);
export default __webpack_public_path__ + "static/media/file-upload-icon.689d72fd.svg";
export { ForwardRef as ReactComponent };